export const STANDARD_TEC_TOOL_ERROR_MESSAGE =
  "TEC Tool is unable to process your request right now. Please try again.";

type ApiFeedbackState = {
  pendingRequests: number;
  errorMessage: string | null;
  errorId: number;
};

type ApiFeedbackListener = () => void;

let state: ApiFeedbackState = {
  pendingRequests: 0,
  errorMessage: null,
  errorId: 0
};

const listeners = new Set<ApiFeedbackListener>();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

const setState = (nextState: Partial<ApiFeedbackState>) => {
  state = {
    ...state,
    ...nextState
  };
  emitChange();
};

export const subscribeToApiFeedback = (listener: ApiFeedbackListener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getApiFeedbackState = () => state;

export const trackApiRequestStart = () => {
  setState({
    pendingRequests: state.pendingRequests + 1,
    errorMessage: null
  });
};

export const trackApiRequestEnd = () => {
  setState({
    pendingRequests: Math.max(0, state.pendingRequests - 1)
  });
};

export const trackApiRequestFailure = () => {
  setState({
    pendingRequests: Math.max(0, state.pendingRequests - 1),
    errorMessage: STANDARD_TEC_TOOL_ERROR_MESSAGE,
    errorId: state.errorId + 1
  });
};

export const showStandardApiError = () => {
  setState({
    errorMessage: STANDARD_TEC_TOOL_ERROR_MESSAGE,
    errorId: state.errorId + 1
  });
};

export const clearApiFeedbackError = () => {
  if (!state.errorMessage) {
    return;
  }

  setState({
    errorMessage: null
  });
};
